import {CompanyFeature} from '../types/CompanyFeature'
import {MenuItem} from '../types/MenuItem'

type LojistasOnlyAccessInput = {
  features: CompanyFeature[]
  dashboardMenu: MenuItem[]
  toolsMenu: MenuItem[]
  lojistasMenu: MenuItem[]
  superAdmin: boolean
}

export const isLojistasOnlyAccess = ({
  features,
  dashboardMenu,
  toolsMenu,
  lojistasMenu,
  superAdmin,
}: LojistasOnlyAccessInput): boolean =>
  !superAdmin &&
  features.length > 0 &&
  features.every((feature) => feature.name.startsWith('lojistas-')) &&
  dashboardMenu.length === 0 &&
  toolsMenu.length === 0 &&
  lojistasMenu.length === 1 &&
  lojistasMenu[0].label === 'Lojistas' &&
  Boolean(lojistasMenu[0].children?.length)
